// React
import React from "react";

import { jwtDecode } from "jwt-decode";
import { useDispatch, useSelector } from "react-redux";
// Third party imports
import { useNavigate } from "react-router-dom";
import { PUBLIC_ROUTES } from "routes";

// Redux
import { setUserProfile } from "redux/slices/profileSlice.jsx";
import { setError, setSnackbar } from "redux/slices/snackbarSlice.jsx";

// APIs
import { getProfile } from "api/profile";

// API
/**
 * Custom hook to fetch user profile data.
 *
 * @returns {Object} An object containing userProfileLoading and reduxUserProfile.
 */
export default function useGetProfile() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = React.useState(true);
  const profile = useSelector((state) => state.profile);
  const fetchProfile = async () => {
    try {
      const response = await getProfile();
      dispatch(setUserProfile(response.data));
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      if (err.response.status === 404) {
        const decoded = jwtDecode(localStorage.getItem("access"));
        navigate(PUBLIC_ROUTES.COMPLETE_REGISTRATION(decoded.user_id));
        dispatch(
          setSnackbar({
            open: true,
            message: "Please complete your profile.",
            severity: "info",
          })
        );
      } else {
        dispatch(setError(err));
      }
    }
  };
  React.useEffect(() => {
    // If user profile is not in redux store, fetch it from the server.
    if (profile.user === null && !window.location.pathname.includes("/profile")) {
      fetchProfile();
    } else {
      setIsLoading(false);
    }
    // eslint-disable-next-line
  }, [dispatch, navigate]);
  return { isLoading, profile };
}
